import React from 'react'

import pagenotfound from '../../assets/images/unavailable.png'
export default function index() {
	return (
		<div style={{
			padding: "5.35%"
		}}>
			<img src={pagenotfound} style={{ marginBottom:"20px", height:"150px",width:"150px",display: "inline"}}></img>
			<h1>This Feature is not available</h1>
		</div>
	)
}
